<template>
  <div style="display: flex;flex-direction: column;align-items: center;">
    <holiday-batch-insert ref="holidayBatchInsert" @reload='getHolidays'></holiday-batch-insert>

    <span class="title">节假日设置</span>
    <span class="title2" @click="insertHoliday">批量插入周六周日</span>
    <div class="calendar shadow-2">
      <el-calendar v-model="restValue">
        <template
            slot="dateCell"
            slot-scope="{date, data}">
            <div class="daySide" @click="changeHoliday(data.day)">
              <span>{{ data.day.split('-').slice(2).join('-') }}</span>
              <div v-if="holiday.indexOf(data.day)>-1" class="xiu">休</div>
            </div>
        </template>
      </el-calendar>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default{
    data(){
      return{
        restValue:new Date(),
        holiday:[]
      }
    },
    methods:{
      //批量插入周六周日
      insertHoliday(){
        this.$refs.holidayBatchInsert.show();
      },

      //***获取假日列表
      getHolidays(){
        let curr = this;
        axios({
          method: 'post',
          url: curr.appURL + '/renli.php',
          data: {
            token: localStorage.token,
            type: 'getHolidays'
          },
        })
        .then(res => {
          curr.holiday = [];
          for(let s of res.data.result){
            curr.holiday.push(s.holiday)
          }
        });
      },
      //***变更某天为休息日或者正常值班
      changeHoliday(day){
        console.log('点击了变更假日');
        let curr = this;
        let text = '';//提示
        let operation = '';//操作 是insert 还是delete
        if(curr.holiday.indexOf(day)>-1){
          text = '将'+day+'取消假日？';
          operation = 'delete';
        }else{
          text = '将'+day+'设置为假日？';
          operation = 'insert';
        }

        curr.$confirm(text, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios({
            method: 'post',
            url: curr.appURL + '/renli.php',
            data: {
              token: localStorage.token,
              type: 'changeHoliday',
              day:day,
              operation:operation
            },
          })
          .then(res => {
            if(res.data.code==0){
              curr.getHolidays();
            }
          });
        });


        // axios({
        //   method: 'post',
        //   url: curr.appURL + '/renli.php',
        //   data: {
        //     token: localStorage.token,
        //     type: 'changeHoliday',
        //     day:day
        //   },
        // })
        // .then(res => {
        //   console.log(res.data);
        // });
      }
    },
    created() {
      this.getHolidays();//获取节假日
    }
  }
</script>

<style scoped>
  .title{
    font-size: 38px;
    font-weight: bold;
    margin-top: 25px;
  }
  .title2{
    color: #888;
    margin-top: 5px;
    cursor: pointer;
  }
  .title2:hover{
    color: #00C5F3;
  }
  .calendar{
    margin-top: 35px;
    width: 36%;
  }
  .daySide{
    width: 100%;height: 100%;position: relative;display: flex;flex-direction: column;align-items: center;justify-content: center;
  }
  .xiu{
    color: white;
    position: absolute;
    width: 16px;
    height: 16px;
    right: 0px;
    bottom: 0px;
    padding: 2px;
    font-size: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: red;
    border-radius: 17px;
  }
</style>



// WEBPACK FOOTER //
// src/view/rest/rest.vue